// extracted by mini-css-extract-plugin
module.exports = {"body":"TextButton_body__20Hc-"};